import { PAGES } from 'src/modules/prismic/content-types'

export function titleMetaTagBuilder(pageName, data) {
  try {
    switch (pageName) {
      case PAGES.PRODUCT:
        return this.$t('PDP seo title', {name: data.name, details: data.details})

      case PAGES.PLP:
        return this.$t('PLP seo title', {collection: data.collection, itemsCategory: data.itemsCategory, filtersText: data.filtersText, market: data.market})

      case PAGES.CLP:
        return this.$t('CLP seo title', {itemsCategory: data.itemsCategory, filtersText: data.filtersText, market: data.market})

      default:
        return data.title
    }
  } catch (error) {
    console.error('Error building title meta tag content', error)
    return 'Zenith Watches'
  }
}

export function descriptionMetaTagBuilder(pageName, data) {
  try {
    switch (pageName) {
      case PAGES.PRODUCT:
        return this.$t('PDP seo description', {name: data.name, itemCategory: data.itemCategory, details: data.details})

      case PAGES.PLP:
        if (data.filters) {
          return this.$t('PLP seo description filters', {collection: data.collection, itemsCategory: data.itemsCategory, filters: data.filters})
        }
        return this.$t('PLP seo description', {collection: data.collection, itemsCategory: data.itemsCategory})

      case PAGES.CLP:
        if (data.filters) {
          return this.$t('CLP seo description filters', {itemsCategory: data.itemsCategory, filters: data.filters})
        }
        return this.$t('CLP seo description', {itemsCategory: data.itemsCategory})

      default:
        return data.description
    }
  } catch (error) {
    console.error('Error building description meta tag content', error)
    return 'Zenith Watches'
  }
}
